const isTouchDevice = function() {
    return (('ontouchstart' in window) || navigator.maxTouchPoints);
};

export {
    isTouchDevice
}
